import { axios } from '@/lib/axios'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-toastify'

export const getZZZ6s = async (query) => {
  const { page, pageSize, sortBy = '', orderBy = 1, filters = {} } = query

  // Transform array filters to comma-separated strings for backend
  const transformedFilters = { ...filters }
  Object.keys(transformedFilters).forEach((key) => {
    if (Array.isArray(transformedFilters[key])) {
      transformedFilters[key] = transformedFilters[key].join(',')
    }
  })

  const params = {
    page,
    limit: pageSize,
    sortBy: sortBy || 'description',
    orderBy,
    ...transformedFilters,
  }
  const response = await axios.get('/ZZZ6s', { params })
  return response.data.result
}

const useZZZ6 = () => {
  const useFetchZZZ6s = (query) => {
    return useQuery({
      queryKey: ['zzz6s', query],
      queryFn: () => getZZZ6s(query),
      onError: (error) => {
        toast.error(error?.response?.data?.message || 'Failed to fetch ZZZ6s')
      },
    })
  }

  return {
    useFetchZZZ6s,
  }
}

export default useZZZ6
